import { render, staticRenderFns } from "./LotteryChoice.vue?vue&type=template&id=1d93822e&scoped=true&"
import script from "./LotteryChoice.vue?vue&type=script&lang=js&"
export * from "./LotteryChoice.vue?vue&type=script&lang=js&"
import style0 from "./LotteryChoice.vue?vue&type=style&index=0&id=1d93822e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d93822e",
  null
  
)

export default component.exports